// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"1029bb5f","453":"0367c34f","963":"e06c9589"}[chunkId] + ".chunk.js";
};